import { apiProxyRequest } from "Api/apiProxyRequest";

export const deleteTFARequest = (userId: string) =>
  apiProxyRequest<void>(`/users/${userId}/totp`, "DELETE");
